(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  // Drawer menu (desktop 3-lines button AND mobile hamburger — same mechanism, different drawer)
  function closeDesktopMega() {
    document.querySelectorAll('.desktop-drawer.is-open, .mobile-drawer.is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.querySelectorAll('.desktop-drawer__panel.is-active').forEach((panel) => panel.classList.remove('is-active'));
    });
    document
      .querySelectorAll('.header__desktop-toggle[aria-expanded="true"], .header__mobile-toggle[aria-expanded="true"]')
      .forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('dd-lock');
  }

  function closeMobileSearch() {
    const bar = document.querySelector('.header__search-bar.mobile-search-active');
    if (!bar) return;
    bar.classList.remove('mobile-search-active');
    const toggle = document.querySelector('[data-mobile-search-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', (event) => {
    const searchToggle = event.target.closest('[data-mobile-search-toggle]');
    if (searchToggle) {
      const bar = document.querySelector('.header__search-bar');
      if (bar) {
        const isActive = bar.classList.toggle('mobile-search-active');
        searchToggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        if (isActive) {
          const input = bar.querySelector('.header__search-input');
          if (input) setTimeout(() => input.focus(), 50);
        }
      }
      return;
    }

    const toggle = event.target.closest('.header__desktop-toggle, .header__mobile-toggle');
    if (toggle) {
      const controlsId = toggle.getAttribute('aria-controls');
      if (!controlsId) return;

      // Move the drawer to <body> so the header's stacking context / announcement bar
      // can never sit on top of it (this was hiding the close button).
      const inHeader = toggle.closest('.header-wrapper');
      const fresh = inHeader ? inHeader.querySelector('#' + CSS.escape(controlsId)) : null;
      let drawer;
      if (fresh) {
        const stale = document.querySelector('body > #' + CSS.escape(controlsId));
        if (stale) stale.remove();
        document.body.appendChild(fresh);
        drawer = fresh;
      } else {
        drawer = document.getElementById(controlsId);
      }
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('dd-lock');
      closeMobileSearch();
      return;
    }

    const opener = event.target.closest('[data-dd-open]');
    if (opener) {
      const panel = document.getElementById(opener.getAttribute('data-dd-open'));
      if (panel) panel.classList.add('is-active');
      return;
    }

    const back = event.target.closest('[data-dd-back]');
    if (back) {
      const panel = back.closest('.desktop-drawer__panel');
      if (panel) panel.classList.remove('is-active');
      return;
    }

    if (event.target.closest('[data-dd-close]')) {
      closeDesktopMega();
      return;
    }

    // Clicked somewhere else entirely: close the mobile search dropdown if it's open.
    if (!event.target.closest('.header__search-bar')) {
      closeMobileSearch();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDesktopMega();
      closeMobileSearch();
    }
  });

  // Theme editor: header is re-rendered after every change, so drop the stale drawer copies in <body>
  function removeStaleDesktopDrawers() {
    document.querySelectorAll('body > .desktop-drawer, body > .mobile-drawer').forEach((drawer) => drawer.remove());
    document.body.classList.remove('dd-lock');
  }
  document.addEventListener('shopify:section:load', removeStaleDesktopDrawers);
  document.addEventListener('shopify:section:unload', removeStaleDesktopDrawers);

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
